// src/pages/PayWidget.js

import React, { useState, useEffect } from "react";
import styles from "../styles/PayWidget.module.css";
// fetchBINData удалён — не использовался (BIN-проверка происходит внутри PaymentForm)
import OrderDetails from "../components/OrderDetails";
import PaymentForm from "../components/PaymentForm";

const PayWidget = () => {
    const [order, setOrder] = useState(null);

    useEffect(() => {
        const savedOrder = localStorage.getItem("order");
        if (savedOrder) {
            setOrder(JSON.parse(savedOrder));
        }
        console.log("Заказ:", JSON.parse(savedOrder));
    }, []);

    return (
        <div className={styles.body}>
            <div className={styles.container}>
                <OrderDetails order={order} />
                <PaymentForm order={order} />
            </div>
        </div>
    );
};

export default PayWidget;



